import LegalLayout from "../components/LegalLayout";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <LegalLayout
      title="How Martingale Playbook works"
      overline="ABOUT · THE METHOD"
      path="/about"
      description="An inside look at how the Playbook analyzes the daily slate, sizes Martingale progressions, and scans for arbitrage opportunities."
    >
      <p className="text-lg">
        We built this because we needed it ourselves. Most &ldquo;betting system&rdquo;
        sites sell a fantasy. The Playbook sells honesty: transparent math, real odds,
        real AI analysis, and the hard truth about what Martingale can and cannot do.
      </p>

      <h2 className="font-display text-2xl text-white mt-10 mb-3">The three things we run every morning</h2>
      <ol className="list-decimal list-inside space-y-3">
        <li>
          <strong>Slate intake.</strong> We pull the day's MLB / NBA / NHL / NFL / UFC card from
          ESPN and live odds from multiple US books via The Odds API.
        </li>
        <li>
          <strong>AI handicapping.</strong> Claude Sonnet 4.5 reads each matchup with the
          starting pitcher / QB / fighter, weather, injury news, public betting %, and the
          two teams' 2025–2026 form. It outputs a pick, a 1–5 star confidence, and a
          written rationale.
        </li>
        <li>
          <strong>Martingale fit.</strong> The pick is mapped to a progression: max safe
          steps against your table limit, bust risk %, and stop-loss rule. If the math
          doesn't survive, the card tells you to pass.
        </li>
      </ol>

      <h2 className="font-display text-2xl text-white mt-10 mb-3">What Pro unlocks</h2>
      <ul className="list-disc list-inside space-y-2">
        <li>Unlimited AI plays across all five sports.</li>
        <li>The arbitrage scanner — locked-in edge opportunities across US books.</li>
        <li>Morning email digest at your preferred hour, plus a weekly recap.</li>
        <li>Full 2025 + 2026 team history embedded in every matchup.</li>
      </ul>

      <h2 className="font-display text-2xl text-white mt-10 mb-3">What we don't do</h2>
      <p>
        We don't take wagers. We don't promise wins. We don't sell touts or bogus
        &ldquo;locks.&rdquo; We're not going to tell you that doubling down after a loss
        always works, because <Link to="/responsible-gambling" className="neon-text underline">
        it doesn't</Link>. What we do is show you the math, give you a rational pick, and
        keep a disciplined log of your results so you know whether you're up or kidding
        yourself.
      </p>

      <div className="mt-10">
        <Link
          to="/register"
          className="inline-block px-6 py-3 bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs"
        >
          Start 3 free days
        </Link>
      </div>
    </LegalLayout>
  );
}
